
function SdSgridFilterColController($scope, TranslationService, $filter, $rootScope, $document, $timeout, SdSgridService) {
    var ctrl = this;

    ctrl.translation = TranslationService.getActiveTranslation();
    ctrl.options = [];

    if (ctrl.loadedOptions.length > 0) {
        setLoadedOptions(ctrl.loadedOptions);
    }

    function setLoadedOptions(loadedOptions) {
        for (var i = 0; i < loadedOptions.length; i++) {
            var options = loadedOptions[i];
            for (var j = 0; j < options.length; j++) {
                var option = options[j];
                if (option.name == ctrl.col.name) {
                    ctrl.col.filterOptions.push(option);
                    ctrl.applied = true;
                }
            }
        }
    }

    /*Definindo a ordenação dos itens, aqueles selecionados que passaram por um filtro estarão no topo da lista*/
    ctrl.orderBy = function (item) {
        if (item.checkedOnAction)
            return -15;
        if (!item.Value)
            return -10;
        if (item.Value)
            return -5;
    };

    /*Disparada nas ações de quando o usuário filtra pelo campo ou fecha e abre novamente o pop-up*/
    ctrl.checkOnAction = function (options) {
        var scrollBox = document.getElementById('filterScroll');
        scrollBox.scrollTop = 0;
        for (var i = 0; i < options.length; i++) {
            if (options[i].IsChecked) {
                options[i].checkedOnAction = true;
            } else {
                options[i].checkedOnAction = false;
            }
        }
    };

    ctrl.takeSize = 500;
    ctrl.skipSize = 0;
    ctrl.search = ''; 

    ctrl.isEmpty = function (value) {
        if (value == null) {
            return true;
        } else {
            return false;
        }
    };

    ctrl.dateOptions = [];
    ctrl.years = [];

    /*Func disparada na pesquisa pelos valores da coluna*/
    ctrl.searchMode = function () {
        //console.log('searchMode');
        ctrl.allFilteredToggled = false;
        ctrl.orderedBySelection = true;
        if (ctrl.serverSearch) { //Chama novamente a função quando possui mais de 500 itens
            ctrl.noData = false;
            ctrl.skipSize = 0;
            ctrl.options = [];
            ctrl.loadOptions(false);
        } else {
            ctrl.checkOnAction(ctrl.options);
        }
    };

    ctrl.loadOptions = function (scroll) {
        if (event)
            event.stopPropagation();

        //console.log('sd-sgrid-filter-col.loadOptions');

        // Retorna quando já está fazendo um carregamento, ou quando não existe mais valores para ser acrescentadi ou a coluna não exige filtro
        if (ctrl.loading == true || ctrl.loadingScroll == true || !ctrl.col.filterOptions || ctrl.noData)
            return;

        if (scroll == false)
            ctrl.loading = true;
        else if (scroll == true)
            ctrl.loadingScroll = true;

        // Quando dados são boolenos atribuimos as opções da coluna de acordo com o objeto pai
        if (ctrl.col.dataType == 'boolean') {
            ctrl.options = ctrl.col.boolOptions;
            ctrl.col.filterOptions = SdSgridService.getColumnFilters(ctrl.prefs.name, ctrl.col.name, ctrl.options);
            if (ctrl.col.filterOptions.length > 0) {
                ctrl.applied = true;
            }
            ctrl.loading = false;
            return;
        }

        ctrl.moreOptions = false;

        // Servico passado pelo objeto
        ctrl.loadColumn(ctrl.index, ctrl.search, ctrl.skipSize, ctrl.takeSize, ctrl.prefs.parentFilter, ctrl.searchString, ctrl.loadedOptions).then(function (response) {
            var data = response.data;

            if (!data)
                return;

            // Condicional da variável que verifica se existem mais dados para carregar
            if (response.data.length == 0)
                ctrl.noData = true;
            else
                ctrl.noData = false;

            // Quando a coluna é do tipo data, zere as opções de filtro
            if (ctrl.col.dataType == 'date')
                ctrl.options = [];

            for (var i = 0; i < data.length; i++) {
                if (data[i] == '')
                    data[i] = null;

                var key;
                var value;

                //Percorre o array vindo do servidor, verifica se o valor é um objeto e instancia os objetos para as opções de filtro
                if (data[i]) {
                    if (typeof data[i] === 'object' && typeof data[i].getMonth !== 'function') {
                        key = data[i].Key;
                        value = data[i].Value;
                    } else {
                        value = data[i];
                    }
                } else {
                    value = null;
                }

                var item = {
                    Value: value,
                    Key: key,
                    IsChecked: false,
                    name: ctrl.col.name
                };

                ctrl.options.push(item);
            }

            ctrl.col.filterOptions.concat(SdSgridService.getColumnFilters(ctrl.prefs.name, ctrl.col.name, ctrl.options)); //Necessário para não perder nenhum filtro que foi adicionado
            ctrl.fillOptionsWithSelected(ctrl.col.filterOptions); //Preenchendo as opções recarregadas com os filtros previamente carregados
            ctrl.checkOnAction(ctrl.options);

            // Broadcast que dispara o filtro por datas
            if (ctrl.col.dataType == 'date')
                $scope.$broadcast('datesLoaded', ctrl.options);

            if (scroll) {
                ctrl.loadingScroll = false;
            }

            if (!ctrl.noData) //Caso ainda tenha dados, é necessário somar no skip o número de dados que você puxou anteriormente
                ctrl.skipSize += ctrl.takeSize;

            if (ctrl.options.length == ctrl.skipSize && !ctrl.noData) { //Caso tenha dados que ainda precisam ser carregados set as variáveis de mostrar a opção 'Carregar mais...'.
                ctrl.moreOptions = true;
                ctrl.serverSearch = true;
            }

            ctrl.loading = false;
        });
    };

    // Verifica após o carregamento de algum dos filtros ficou faltando, adicionando os que faltam
    ctrl.fillOptionsWithSelected = function (filterOptions) {
        var options = ctrl.options;
        for (var i = 0; i < filterOptions.length; i++) {
            var add = true;
            for (var j = 0; j < options.length; j++) {
                if (options[j].Key == filterOptions[i].Key && options[j].Value == filterOptions[i].Value) {
                    options[j] = filterOptions[i];
                    add = false;
                }
            }
            if (add) {
                options.push(filterOptions[i]);
            }
        }
    };

    // Func que faz a mímica do filter no ng-repeat, ele libera tudo aquilo que está selecionado e tudo aquilo que está filtrado pelo campo de pesquisa
    ctrl.searchFilter = function (item) {
        var search = ctrl.search;
        //console.log('searchFilter ' + search + ' => ' + item.Key + ' ' + item.Value);
        if (item.Key == 'SELECTALL' || item.Key == 'SELECTALLFILTERED')
            return false;

        if ((item.Value instanceof Date))
            return true;

        if (item.Value == null && item.Key == null) {
            var undef = ctrl.translation.Undefined;
            if (undef.toUpperCase().includes(search.toUpperCase()))
                return true;
        }

        if (item.Key && item.Key != null) {
            if (item.Key.toUpperCase().includes(search.toUpperCase()))
                return true;
        }

        if (item.Value && item.Value != null) {
            if (item.Value.toUpperCase().includes(search.toUpperCase()))
                return true;
        }

        if (item.Value && item.Value != null) {
            if (ctrl.translation[item.Value]) {
                if (ctrl.translation[item.Value].toUpperCase().includes(search.toUpperCase())) {
                    return true;
                }
            }
        }

        for (var i = 0; i < ctrl.col.filterOptions.length; i++) {
            var filterOption = ctrl.col.filterOptions[i];
            if (filterOption.Key) {
                if (item.Key) {
                    if (filterOption.Key.toUpperCase() == item.Key.toUpperCase())
                        return true;
                }
            }
            if (filterOption.Value) {
                if (item.Value) {
                    if (filterOption.Value.toUpperCase() == item.Value.toUpperCase())
                        return true;
                }
            }
            if (filterOption.Key == null && filterOption.Value == null && item.Value == null && item.Key == null) {
                return true;
            }
        }

        return false;
    };

    // Func que dá o trigger inicial no carregamento
    ctrl.checkLoading = function (ev) {
        console.log('checkLoading');

        //if (ctrl.isOpen) {
        if (ctrl.isOpen && ctrl.options.length == 0) {
            ctrl.loadOptions(false);
        }
        else if (ctrl.isOpen) {
            ctrl.checkOnAction(ctrl.options);
        }

        ctrl.toggleDropdown(ev);
    };

    ctrl.toggled = function () {
        if (!ctrl.col.options) {
            ctrl.onLoadOptions({
                column: ctrl.col
            });
        }
    };

    // Func para ordernação
    ctrl.selectSort = function (col, sortType) {
        if (ctrl.col.sortType != sortType)
            ctrl.col.sortType = sortType;
        else
            ctrl.col.sortType = '';

        if (col) {
            ctrl.onSelectSort({
                column: ctrl.col
            });
            event.stopPropagation();
            ctrl.isOpen = false;
        }
        $rootScope.$broadcast('sort_filter', col);
    };

    ctrl.stopPropagation = function (event) {
        if (event) {
            event.stopPropagation();
        }
    };

    //OK
    ctrl.selectOption = function (option) {
        if (option === 0 || option) {
            option.IsChecked = !option.IsChecked;      
            if (!option.IsChecked) {
                ctrl.allToggled = false;
                ctrl.allFilteredToggled = false;
                setFilterOptions(ctrl.options);
            } else {
                ctrl.col.filterOptions.push(option);
            }
        }
    };

    //OK
    function setFilterOptions(options) {
        ctrl.col.filterOptions = [];
        for (var i = 0; i < options.length; i++) {
            var option = options[i];
            if (option.IsChecked) {
                ctrl.col.filterOptions.push(option);
            }
        }
    }

    //OK
    ctrl.isChecked = function (option) {
        if (ctrl.allToggled) {
            option.IsChecked = true;
            return true;
        } else if (ctrl.allFilteredToggled && ctrl.searchFilter(option)) {
            option.IsChecked = true;
            return true;
        } else if (option.IsChecked)
            return true;
        else
            return false;
    };

    //OK
    function spliceOption(key) {
        var result = ctrl.col.filterOptions.find(function (item) {
            return item.Key == key;
        });
        var index = ctrl.col.filterOptions.indexOf(result);
        if (index !== -1)
            ctrl.col.filterOptions.splice(index, 1);
    }

    //OK
    ctrl.allToggled = false;
    ctrl.toggleAll = function () {
        ctrl.allToggled = !ctrl.allToggled;
        ctrl.col.filterOptions = [];
        if (ctrl.allToggled) {
            ctrl.allFilteredToggled = true;
            ctrl.col.filterOptions.push({ Key: 'SELECTALL', Value: ctrl.translation.Filter_All });
        } else {
            spliceOption('SELECTALL');
            ctrl.allFilteredToggled = false;
            for (var i = 0; i < ctrl.options.length; i++) {
                ctrl.options[i].IsChecked = false;
                ctrl.options[i].checkedOnAction = false;
            }
        }
    };

    //OK
    // Verifica opções selecionadas em relação as disponíveis, retornando o estado do botão mostrar todos
    ctrl.selectState = function () {
        if (ctrl.col.filterOptions) {
            if (ctrl.allToggled || (ctrl.col.filterOptions.length == ctrl.options.length && !ctrl.serverSearch && ctrl.options.length > 0)) {
                ctrl.allToggled = true;
                return 'all';
            }
            else if (ctrl.col.filterOptions.length == 0) {
                return 'none';
            } else {
                return 'partial';
            }
        }
    };

    ////REVER
    ctrl.toggleAllFiltered = function () {
        ctrl.allFilteredToggled = !ctrl.allFilteredToggled;
        if (!ctrl.allFilteredToggled) {
            ctrl.col.filterOptions = [];
            ctrl.allToggled = false;
            setFilteredOptions(false);
        } else {
            setFilteredOptions(true);
            setFilterOptions(ctrl.options);
        }
    };

    function setFilteredOptions(state) {
        for (var i = 0; i < ctrl.options.length; i++) {
            if (ctrl.searchFilter(ctrl.options[i])) {
                ctrl.options[i].IsChecked = state;
            }
        }
    }

    ////REVER
    ctrl.selectFilteredState = function () {
        var filteredCount = ctrl.options.filter(function (item) {return ctrl.searchFilter(item) }).length;
        if (ctrl.col.filterOptions) {
            if (ctrl.allFilteredToggled || (ctrl.col.filterOptions.length == filteredCount && filteredCount > 0)) {
                return 'all';
            }
            else if (ctrl.col.filterOptions.length == 0)
                return 'none';
            else
                return 'partial';
        }
    };

    ctrl.hasFilters = function (col) {
        if (col.filterOptions) {
            if (col.filterOptions.length > 0 && ctrl.applied)
                return true;
        }
        return false;
    };

    // Aplicação dos filtros na pesquisa
    ctrl.ok = function () {
        var filterOptions;
        filterOptions = $filter('unique')(ctrl.col.filterOptions, 'Value');
        ctrl.col.filterOptions = filterOptions;
        if (ctrl.col.dataType == 'date') {
            var years = ctrl.years;
            ctrl.col.filterOptions = [];
            for (var i = 0; i < years.length; i++) {
                for (var j = 0; j < years[i].months.length; j++) {
                    for (var k = 0; k < years[i].months[j].days.length; k++) {
                        if (years[i].months[j].days[k].isChecked == true) {
                            var value = {
                                Value: new Date(years[i].Value, years[i].months[j].Value, years[i].months[j].days[k].Value),
                                dataType: 'date'
                            };
                            ctrl.col.filterOptions.push(value)
                        }
                    }
                }
            }
        }
        ctrl.applied = true;
        ctrl.onSelectOption({
            column: ctrl.col
        });
        event.stopPropagation();
        SdSgridService.setColumnFilters(ctrl.col.name, ctrl.col.filterOptions);
        ctrl.isOpen = false;

        //Marca outros filtros como 'dirty'
        $rootScope.$broadcast('apply_filter', ctrl.col);
    };

    ctrl.cancel = function () {
        ctrl.col.included = false;
        ctrl.isOpen = false;
    };

    ctrl.remove = function () {
        ctrl.allToggled = false;
        ctrl.allFilteredToggled = false;
        if (ctrl.col.dataType == 'date') {
            ctrl.cleanAllDates();
        }
        for (var i = 0; i < ctrl.options.length; i++) {
            ctrl.options[i].IsChecked = false;
            ctrl.options[i].checkOnAction = false;
        }
        ctrl.col.sortType = '';
        ctrl.col.filterOptions = [];
        ctrl.ok();
    };

    ctrl.cleanAllDates = function () {
        var years = ctrl.years;
        for (var i = 0; i < years.length; i++) {
            var year = years[i];
            for (var j = 0; j < years[i].months.length; j++) {
                for (var k = 0; k < years[i].months[j].days.length; k++) {
                    years[i].months[j].days[k].isChecked = false;
                }
            }
        }
        ctrl.years = years;
    };

    ctrl.copyFilters = function () {
        // create temp element
        var copyElement = document.createElement("span");
        copyElement.appendChild(document.createTextNode(JSON.stringify(ctrl.col.filterOptions)));
        copyElement.id = 'tempCopyToClipboard';
        angular.element(document.body.append(copyElement));

        // select the text
        var range = document.createRange();
        range.selectNode(copyElement);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);

        // copy & cleanup
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
        copyElement.remove();
    };

    ctrl.pasteFilters = function () {
        navigator.clipboard.readText().then(function (clipboard) {
            var pastedFilters = JSON.parse(clipboard);
            for (var i = 0; i < pastedFilters.length; i++) {
                if (pastedFilters[i].name == ctrl.col.name) {
                    if (pastedFilters[i].Key == 'SELECTALLFILTERED') {
                        ctrl.search = pastedFilters[i].Value;
                        ctrl.allFilteredToggled = true;
                    }
                    if (pastedFilters[i].Key == 'SELECTALL') {
                        ctrl.allToggled = true;
                    }
                    pastedFilters[i].IsChecked = true;
                    ctrl.col.filterOptions.push(pastedFilters[i]);
                }
            }
            ctrl.fillOptionsWithSelected(ctrl.col.filterOptions);
            ctrl.checkOnAction(ctrl.options);
            $scope.$apply();
        });
    };

    ctrl.clearOptions = function () {
        ctrl.noData = false;
        ctrl.skipSize = 0;
        ctrl.options = [];
    };

    $scope.$on('delete_filter', function (event, filter) {
        if (filter && filter[0].name == ctrl.col.name) {
            ctrl.remove();
        }
        else {
            //console.log('filter removido');
            ctrl.clearOptions();
        }
    });

    $scope.$on('sort_filter', function (event, col) {
        if( col != ctrl.col) {
            ctrl.col.sortType = '';
        }
    });

    $scope.$on('apply_filter', function (event, col) {
        if (col != ctrl.col) {
            //console.log('filtro APLICADO para: ' + col.name);
            ctrl.clearOptions();
        }
    });

    $scope.$on('inputSearch', function (event, eventArgs) {
        //console.log('filtro MUDOU!: ');
        ctrl.clearOptions();
    });

    $scope.$on('onParentFilterChanged', function (event, eventArgs) {
        //console.log('filtro parent MUDOU!: ');
        ctrl.clearOptions();
    });

    $scope.$on('onTogleFilter', function (ev, col) {
        console.log('togle column ' + col.name);
        if (col == ctrl.col) {
            var isOpen = ctrl.isOpen;
            $timeout(function () {
                ctrl.isOpen = !isOpen;
                ctrl.checkLoading();
            }, 10);
        }        
    });

    $scope.$broadcast('onParentFilterChanged', $scope.filterString);

    ctrl.getAscText = function (type) {
        if (!ctrl.translation) {
            return;
        }
        if (type == 'date')
            return ctrl.translation.OrderOldToRecent;
        if (type == 'boolean')
            return ctrl.translation.OrderFalseToTrue;
        else
            return ctrl.translation.OrderAToZ;
    };

    ctrl.getAscIcon = function (type) {
        if (type == 'date')
            return 'fa-sort-amount-asc';
        if (type == 'boolean')
            return 'fa-sort-asc';
        else
            return 'fa-sort-alpha-asc';
    };

    ctrl.getDescText = function (type) {
        if (!ctrl.translation) {
            return;
        }
        if (type == 'date')
            return ctrl.translation.OrderRecentToOld;
        if (type == 'boolean')
            return ctrl.translation.OrderTrueToFalse;
        else
            return ctrl.translation.OrderZToA;
    };

    ctrl.getDescIcon = function (type) {
        if (type == 'date')
            return 'fa-sort-amount-desc';
        if (type == 'boolean')
            return 'fa-sort-desc';
        else
            return 'fa-sort-alpha-desc';
    };

    ctrl.toggleDropdown = function ($event) {
        //console.log('toggleDropdown');
        //funcionar sem evento
        var dropdownButton;
        if ($event) {
            dropdownButton = $event.currentTarget;
        }
        else {
            var drops = $('#dropdown-button');
            dropdownButton = drops.length > 0 ? drops[0] : null;
            if (!dropdownButton) {
                return;
            }
        }
        var myDropdown = $document.find('#dropdown-filter-col');
        var dropdownWidth = myDropdown.outerWidth();
        var screenWidth = window.innerWidth;
        var dropdownRight = angular.element(dropdownButton).offset().left + dropdownWidth;
        ctrl.isLeft = dropdownRight > screenWidth;
    };
}

SdSgridFilterColController.$inject = ['$scope', 'TranslationService', '$filter', '$rootScope', '$document', '$timeout', 'SdSgridService'];

seedWebApp.component('sdSgridFilterCol', {
    controller: SdSgridFilterColController,
    bindings: {
        col: '=',
        isLoading: '=',
        index: '<',
        onSelectOption: '&',
        onSelectSort: '&',
        onLoadOptions: '&',
        loadColumn: '<',
        loadedOptions: '<',
        prefs: '<',
        searchString: '<',
    },
    templateUrl: '/SPA/Components/serviceGrid/sd-sgrid-filter-col.html' + seedWebApp.buildVersion
});